import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
// import { useDispatch, useSelector } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNotify } from '../hooks/useNotify';
import { define } from '../data/globals'

const NotifyList2 = () => {
    const notifyListStore = useSelector(state => state.notifyList)
    const { delNotify } = useNotify()

    return (
        <>
            <div className='notifyArea'>
            <TransitionGroup className="">
                {notifyListStore.map((item)=>
                    <CSSTransition
                        key={item.id}
                        timeout={2000}
                        classNames="notify"
                        mountOnEnter
                        unmountOnExit
                    >
                    <div className={`notifyItem ${item.class}`}>
                        <div className='notifyText' dangerouslySetInnerHTML={{ __html: item.notifyText }} 
                        /><span
                            className='delNotifyBtn'
                            onClick={()=>delNotify(item.id)}
                            ><img src={ define.pathToGraphics + '/delete4_14px.png' } alt=''/></span></div>
                    </CSSTransition>
                )}
            </TransitionGroup>
            </div>
        </>
    )
}

export default NotifyList2;